<template>
  <div class="empty-reviews">
    <div class="empty-reviews__wrap">
      <img class="empty-reviews__img" src="/img/svgo/product-page/review.svg" alt="review-icon" />
      <span class="empty-reviews__text" v-html="reviewsText"></span>
      <AddCommentButton
        class="add-comment-btn"
        type="pseudo-link"
        :post-comment-endpoint="endpoint"
        :form-type="type"
        :is-questions="true"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AddCommentButton from '../../comments/AddCommentButton'

export default {
  name: 'EmptyReviews',
  components: {
    AddCommentButton
  },
  computed: {
    ...mapState({
      auth: state => state.user.auth
    }),
    reviewsText () {
      return this.isQuestions ? this.$t('questions.no_questions') : this.$t('comment.no.answers')
    }
  },
  props: {
    isQuestions: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    productId: {
      type: Number,
      default: null
    }
  }
}
</script>

<style scoped lang="sass">

.empty-reviews
  display: block
  width: 100%
  background-color: #F8F8F8
  border-radius: 5px

.empty-reviews__wrap
  display: flex
  flex-direction: column
  align-items: center
  padding: 60px 30px

.empty-reviews__text
  font-size: 18px
  text-align: center
  margin: 60px 0

.empty-reviews__small-text
  font-size: 14px
  text-align: center
</style>
